import { computeSummary } from "@/domains/watches/hooks/useWatchDefaults";
import type { JsonValue } from "@/shared/lib/types";
import { T } from "@/shared/ui/DesignLib";
import React from "react";

// ─── Props ──────────────────────────────────────────────────────────────────

interface WatchSummaryProps {
  ticker: string;
  intent: string;
  contractExpiry?: string;
  contractStrike?: string;
  contractType?: string;
  policy: {
    max_duration_days: number;
    evaluation_interval_minutes: number;
    max_alerts_per_watch: number;
    cooldown_minutes: number;
    market_hours_only: boolean;
  };
  intentParams: Record<string, JsonValue>;
  alertMode?: "one_and_done" | "keep_watching";
}

// ─── Component ──────────────────────────────────────────────────────────────

const WatchSummary: React.FC<WatchSummaryProps> = ({
  ticker,
  intent,
  contractExpiry,
  contractStrike,
  contractType,
  policy,
  intentParams,
  alertMode,
}) => {
  const summary = ticker
    ? computeSummary({
        ticker,
        intent,
        contractExpiry,
        contractStrike,
        contractType,
        policy,
        intentParams,
        alertMode,
      })
    : "";

  return (
    <div
      style={{
        background: "rgba(0,184,219,0.03)",
        borderLeft: `2px solid ${T.primary}`,
        borderRadius: 4,
        padding: "12px 14px",
        fontFamily: T.mono,
        fontSize: "0.6rem",
        lineHeight: 1.6,
      }}
      className="text-tab-text"
    >
      {ticker
        ? summary
        : "Select a ticker to see your watch summary"}
    </div>
  );
};

export default WatchSummary;
